// In pixels. The width the user drags to is remembered, within these bounds.
export const SIDE_PANEL_WIDTH = {
  default: 400,
  min: 320,
  max: 600,
};
